import { h } from "preact";
import { observer } from "mobx-react";
function OrderButtonLabel(props) {
    const { text } = props;
    return h("span", { class: "u-text-bold u-text-wrap" }, text);
}
export default observer(OrderButtonLabel);
